import React from "react";
import styles from "./mentor_testimonial.module.scss";

export const MentorTestimonial = () => {
  return (
    <section className={styles.section_testimonial}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2>Our Testmonial</h2>
          <p className={"font-medium"}>We have 5000+ University reviews</p>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolorem
            molestiae eum totam porro veniam perspiciatis autem qui nemo, quos
            magni, laboriosam aspernatur officia recusandae necessitatibus
            praesentium maiores alias earum sequi.
          </p>
          <div>
            <h2>Center Mode</h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MentorTestimonial;
